'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'link-horizontal';
var width = 576;
var height = 512;
var aliases = ["chain-horizontal"];
var unicode = 'e1cb';
var svgPathData = ['', 'M296 288c57.4 0 104-46.6 104-104S353.4 80 296 80L152 80c-57.4 0-104 46.6-104 104 0 34 16.3 64.1 41.4 83.1-5.2 16.2-8.3 33.3-9.2 50.9-47.8-25.6-80.2-76-80.2-134 0-83.9 68.1-152 152-152l144 0c83.9 0 152 68.1 152 152S379.9 336 296 336l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0zm232 40c0-31-13.6-58.9-35.2-78 5.7-16.3 9.4-33.7 10.6-51.6 43.5 26.7 72.5 74.8 72.5 129.6 0 83.9-68.1 152-152 152l-144 0c-83.9 0-152-68.1-152-152s68.1-152 152-152l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-57.4 0-104 46.6-104 104s46.6 104 104 104l144 0c57.4 0 104-46.6 104-104z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkHorizontal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;